import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import SEOHead from "./components/SEOHead";
import Home from "./pages/Home";
import WhyDuramix from "./pages/WhyDuramix";
import Products from "./pages/Products";
import Works from "./pages/Works";
import DIY from "./pages/DIY";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Blogs from "./pages/Blogs";
import QualitySafety from "./pages/QualitySafety";
import BlogDetails from "./pages/BlogDetails";
import Careers from "./pages/Careers";
import Faq from "./pages/Faq";
import ComingSoon from "./pages/ComingSoon";

function App() {//basename="/ssc"  {/*<BrowserRouter  basename="/ssc">*/}}
  return (
   
    <div className="App">
      <BrowserRouter >
      {/*<BrowserRouter>*/}
        <SEOHead />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/why-sscreadymix" element={<WhyDuramix />} />
          <Route path="/products" element={<Products />} />
          <Route path="/works" element={<Works />} />
          <Route path="/quality" element={<QualitySafety />} />
          <Route path="/diy" element={<DIY />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/blogs/:id" element={<BlogDetails />} />

          <Route
  path="/privacy-policy"
  element={
    <ComingSoon
      title="Privacy Policy"
      subtitle="Our privacy policy page is currently being prepared and will be available soon."
    />
  }
/>

<Route
  path="/terms-and-conditions"
  element={
    <ComingSoon
      title="Terms & Conditions"
      subtitle="Terms and conditions content will be published shortly."
    />
  }
/>

<Route
  path="/request-quote"
  element={
    <ComingSoon
      title="Request Quote"
      subtitle="Online quotation request system is coming soon."
    />
  }
/>
<Route
  path="*"
  element={
    <ComingSoon
      title="404"
      subtitle="The page you are looking for does not exist."
    />
  }
/>
        </Routes>
        <Footer />
        <WhatsAppButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
